import { Directive, ElementRef, inject } from "@angular/core";
import { fromEvent } from "rxjs";
import { EmotionAngularEvents } from "@services/emotion-events.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Directive({
	selector: "[app-struts]",
	standalone: true,
})
export class StrutsDirective {
	readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

	constructor() {
		fromEvent(window, EmotionAngularEvents.SCROLL_TOP)
			.pipe(takeUntilDestroyed())
			.subscribe(() => this.elementRef.nativeElement?.scrollIntoView({ behavior: "smooth" }));
	}

	append(el: HTMLElement) {
		this.elementRef.nativeElement?.append(el);
	}

	display() {
		this.elementRef.nativeElement.style.display = "block";
	}

	hide() {
		this.elementRef.nativeElement.style.display = "none";
	}
}
